/**
 * المرحلة 1.35 — «وذلك نظير»: the price list's leaves (GET /api/price-list
 * ?flat=1) as cascading dropdowns — category, then service, then its detail.
 * A leaf one or two levels down ends the cascade where it sits, so «كشف
 * أطفال» is two picks and «جهاز سرنجات — ثلاثي» is three.
 *
 * Pure; the leaves arrive in the editor's order (lib/priceList.leaves), and
 * every level keeps it.
 */

/**
 * The dropdowns for what has been picked so far.
 *
 * @param {Array<{pathIds:number[], path:string[]}>} leaves
 * @param {Array<number|string>} picked  the chosen id at each level
 * @returns {{ levels: Array<{ level:number, options:Array<{id:number,name:string,leaf:object|null}>, value:number|null }>, leaf: object|null }}
 */
export function cascade(leaves, picked = []) {
  const levels = [];
  let pool = Array.isArray(leaves) ? leaves : [];
  for (let level = 0; level < 3; level += 1) {
    const options = [];
    const seen = new Set();
    for (const leaf of pool) {
      const id = leaf.pathIds[level];
      if (id === undefined || seen.has(id)) continue;
      seen.add(id);
      options.push({ id, name: leaf.path[level], leaf: leaf.pathIds.length === level + 1 ? leaf : null });
    }
    if (!options.length) break;
    const wanted = picked[level] === undefined || picked[level] === null || picked[level] === '' ? null : Number(picked[level]);
    const value = wanted !== null && seen.has(wanted) ? wanted : null;
    levels.push({ level, options, value });
    if (value === null) return { levels, leaf: null };
    const chosen = options.find((o) => o.id === value);
    if (chosen.leaf) return { levels, leaf: chosen.leaf };
    pool = pool.filter((l) => l.pathIds[level] === value);
  }
  return { levels, leaf: null };
}

/** The picks that lead to one leaf (to show a line again in its dropdowns). */
export const picksOf = (leaf) => (leaf && Array.isArray(leaf.pathIds) ? [...leaf.pathIds] : []);

/** How many priced leaves sit under each category: { [categoryId]: n }. */
export function countByCategory(leaves) {
  const out = {};
  for (const leaf of Array.isArray(leaves) ? leaves : []) out[leaf.categoryId] = (out[leaf.categoryId] || 0) + 1;
  return out;
}
